import { h } from "preact";

import i18n from "../../i18n.js";
import Button from "../Button.jsx";
import Icon from "../Icon.jsx";

export default function CompanyReferralSection({ hasPartnerPage }) {
  if (hasPartnerPage === null) return null;

  return (
    <div class="referral-page referral-page--marketpalce-referral mt-48">
      <div class="row">
        {hasPartnerPage ? (
          <div class="col s12 push-l3 l6 text-center pt-48">
            <Icon class="mt-32" big>
              headset
            </Icon>
            <h1 class="t-subtitle1 t-subtitle1--margin-small mt-32">
              {i18n.t("pages.partner_referral.marketplace_true.title")}
            </h1>
            <p class="t-body3 color-shades-grey mb-48">
              {i18n.t("pages.partner_referral.marketplace_true.description")}
            </p>

            <Button primary to="mailto:info@nioomi.com" iconBack="send">
              {i18n.t("pages.partner_referral.marketplace_true.button")}
            </Button>
          </div>
        ) : (
          <div class="col s12 push-l3 l6 text-center pt-48">
            <Icon class="mt-32" big>
              handshake_big
            </Icon>
            <h1 class="t-subtitle1 t-subtitle1--margin-small mt-32">
              {i18n.t("pages.partner_referral.marketplace_false.title")}
            </h1>
            <p class="t-body3 color-shades-grey">
              {i18n.t("pages.partner_referral.marketplace_false.description")}
            </p>
            <p class="t-body3 color-shades-grey mb-48">
              {i18n.t("pages.partner_referral.marketplace_false.description2")}
            </p>

            <Button primary to="mailto:info@nioomi.com" iconBack="send">
              {i18n.t("pages.partner_referral.marketplace_false.button")}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
